import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { TranfertFormPrimaire } from '../models/tranfertFormPrimaire';
import { TransfertFormBussiness } from '../models/transfertFormBussiness';
import { PrelevementSoftPayRequest } from '../models/prelevementSoftPayRequest';
import { TransferApiResponse } from '../models/transferApiResponse';

@Injectable({ providedIn: 'root' })
export class TransactionService {
  private host: string = environment.apiUrl;

  constructor(private http: HttpClient) { }

  getUtilisateurAchats() {
    const username = localStorage.getItem('usernameThatUserIsNowConnect2345789');
    return this.http.get(this.host + "/primary/account/transactions/achats/" + username);
  }

  getUtilisateurDepots() {
    const username = localStorage.getItem('usernameThatUserIsNowConnect2345789');
    return this.http.get(this.host + "/primary/account/transactions/depots/" + username);
  }

  getUtilisateurRetrais() {
    const username = localStorage.getItem('usernameThatUserIsNowConnect2345789');
    return this.http.get(this.host + "/primary/account/transactions/retraits/" + username);
  }

  getUtilisateurTransferts() {
    const username = localStorage.getItem('usernameThatUserIsNowConnect2345789');
    return this.http.get(this.host + "/primary/account/transactions/transferts/" + username);
  }

  getUtilisateurMensualites() {
    const username = localStorage.getItem('usernameThatUserIsNowConnect2345789');
    return this.http.get(this.host + "/primary/account/transactions/mensualites/" + username);
  }

  verifierCodeDeSecurite(code: string, username: string) {
    return this.http.get<boolean>(this.host + "/primary/account/transactions/verifier/code/de/securite/" + code + "/" + username);
  }

  transfertPrimaire(formdata: TranfertFormPrimaire) {
    return this.http.post<TransferApiResponse>(this.host + "/primary/account/transactions/transfert/vers/compte/primaire/v2", formdata);
  }

  transfertBussness(formdata: TransfertFormBussiness) {
    return this.http.post<TransferApiResponse>(this.host + "/primary/account/transactions/transfert/vers/compte/affaire/v2", formdata);
  }

  getUtilisateursBaccountAchats(baccountNumber: any) {
    return this.http.get(this.host + "/business/transactions/" + baccountNumber + "/achats");
  }

  getUtilisateursBaccountMensualites(baccountNumber: any) {
    return this.http.get(this.host + "/business/transactions/" + baccountNumber + "/mensualites");
  }

  getUtilisateursBussnessTransfertTransaction(baccountNumber: any) {
    return this.http.get(this.host + "/business/transactions/" + baccountNumber + "/transferts");
  }

  getUtilisateursBaccountRetraits(baccountNumber: any) {
    return this.http.get(this.host + "/business/transactions/" + baccountNumber + "/retraits");
  }

  getUtilisateursBaccountDepots(baccountNumber: any) {
    return this.http.get(this.host + "/business/transactions/" + baccountNumber + "/depots");
  }

  getUtilisateursBaccountFacturation(baccountNumber: any) {
    return this.http.get(this.host + "/business/transactions/" + baccountNumber + "/facturations");
  }

  updateFacturation(facturationid: any, typ: any) {
    return this.http.post(this.host + "/users/profile/facturation/update/" + facturationid + "/" + typ, null);
  }

  transfertMensualite(facturationid: any, baccountNumber: any) {
    return this.http.post(this.host + "/business/facturation/make/transfert/" + facturationid + "/" + baccountNumber, null);
  }

  prelevementSoftPay(payload: PrelevementSoftPayRequest) {
    return this.http.post(`${this.host}/online/purchase`, payload);
  }

  paySubscription(payload: {
    primaryAccountNumber: string;
    businessAccountNumber: string;
    amount: number;
    currency?: string;
    referenceId?: number;
    periodicity?: 'MONTHLY' | 'YEARLY';
    autoRenew?: boolean;
  }) {
    return this.http.post(`${this.host}/online/subscription/pay`, payload);
  }

  confirmDelivery(purchaseTransactionId: number, payload: { businessAccountId?: number; businessAccountCode?: string; currency?: string; releaseNow?: boolean; }) {
    return this.http.post(`${this.host}/online/purchase/${purchaseTransactionId}/confirm-delivery`, payload);
  }

  requestReturn(purchaseTransactionId: number, payload: { businessAccountId?: number; businessAccountCode?: string; currency?: string; amount?: number; reason?: string; }) {
    return this.http.post(`${this.host}/online/purchase/${purchaseTransactionId}/return-request`, payload);
  }

  confirmReturn(purchaseTransactionId: number, payload: { businessAccountId?: number; businessAccountCode?: string; currency?: string; }) {
    return this.http.post(`${this.host}/online/purchase/${purchaseTransactionId}/return-confirm`, payload);
  }
}
